import { render, staticRenderFns } from "./ErrorView.vue?vue&type=template&id=741761ba&scoped=true"
import script from "./ErrorView.ts?vue&type=script&lang=ts&external"
export * from "./ErrorView.ts?vue&type=script&lang=ts&external"
import style0 from "./ErrorView.vue?vue&type=style&index=0&id=741761ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741761ba",
  null
  
)

export default component.exports